import { jsxs as F, jsx as s } from "react/jsx-runtime";
import * as A from "react";
import { forwardRef as ce, useRef as h, useMemo as W, useCallback as o, useEffect as m, useImperativeHandle as ue } from "react";
import n from "./style.module.less.js";
import L from "./send-arrow.svg.js";
import pe from "./attach-plus.svg.js";
import { FileChip as fe } from "./file-chip/index.js";
import { massageFilename as O } from "../../../utils/massage-filename.js";
import { MakeMeShiny as de } from "./shiny-border.js";
const he = ce((j, K) => {
  const {
    id: D,
    onSendMessage: S,
    className: z,
    inputsClassName: q,
    chatInputClassName: G,
    disabled: i,
    disableFileInput: M,
    failedFiles: y,
    onInput: J,
    placeholder: Q,
    sendOnEnter: k,
    shiny: U = !1,
    chatInputRef: V,
    externalMessage: c,
    setExternalMessage: f,
    classNames: a,
    autoFocus: X = !0,
    truncateOnBlur: E,
    onFocus: Y,
    onBlur: Z,
    preTextIcon: C
  } = j, b = h(null), [g, v] = A.useState(""), x = W(() => c ?? g, [g, c]), w = o(
    (e) => {
      f ? f(e) : v(e);
    },
    [f]
  );
  m(() => {
    c != null && v(c);
  }, [c]);
  const $ = h(null), [r, l] = A.useState([]), B = h(null), _ = h(null), ee = h(null), d = A.useRef(null), N = o(
    async (e = void 0) => {
      var t;
      if (e == null || e.preventDefault(), e == null || e.stopPropagation(), !i)
        try {
          (t = d.current) == null || t.focus(), await S({ text: x, files: r }), w(""), l([]);
        } catch {
        }
    },
    [i, x, r, S, w]
  ), te = o(
    (e) => {
      k && e.key === "Enter" && !e.shiftKey && (e.preventDefault(), N());
    },
    [k, N]
  ), R = () => {
    const e = d.current;
    e && (e.style.height = "auto", e.style.height = `${e.scrollHeight}px`), e && B.current && (e.style.height = "auto", e.style.height = `${e.scrollHeight}px`);
  };
  m(() => (window.addEventListener("resize", R), () => {
    window.removeEventListener("resize", R);
  }), []), m(() => {
    R();
  }, [x]);
  const ne = (e) => {
    e.preventDefault(), $.current && $.current.click();
  }, re = o(
    (e) => {
      var p;
      const t = (p = e.clipboardData) == null ? void 0 : p.items;
      if (t) {
        const T = [];
        for (let I = 0; I < t.length; I++)
          if (t[I].kind === "file") {
            const P = t[I].getAsFile();
            P && T.push(P);
          }
        T.length && (l([...r, ...T]), e.preventDefault());
      }
    },
    [r, l]
  ), ae = o(
    (e) => {
      if ($.current) {
        const t = e.map(O);
        l([...r, ...t]);
      }
    },
    [r]
  );
  ue(
    K,
    () => ({
      ...b.current,
      // Spread the HTMLDivElement properties
      inputContainerRef: b,
      addFiles: ae,
      setMessage: v,
      focusTextarea: () => {
        var e;
        return (e = d.current) == null ? void 0 : e.focus();
      },
      blurTextarea: () => {
        var e;
        return (e = d.current) == null ? void 0 : e.blur();
      }
    })
  );
  const se = o(
    (e) => {
      const t = [...r];
      t.splice(e, 1), l(t);
    },
    [r, l]
  );
  m(() => {
    var e;
    i ? (w(""), l([])) : (e = d.current) == null || e.focus({
      preventScroll: !0
    });
  }, [w, i]);
  const ie = o(
    (e) => {
      const t = Array.from(e.target.files ?? []).map(O);
      l((p) => [...p, ...t]);
    },
    []
  );
  m(() => {
    y && l((e) => e.filter((t) => !y.includes(t)));
  }, [y]);
  const le = o(
    (e) => {
      e.preventDefault(), e.stopPropagation();
      const t = e.target.value;
      i || (f ? f(t) : v(t));
    },
    [i, f]
  ), u = W(() => c ?? g, [c, g]), oe = o((e) => {
    const t = e.trimStart();
    if (!t) return "";
    const p = t.indexOf(`
`);
    return p === -1 ? t : t.substring(0, p) + "...";
  }, []), H = /* @__PURE__ */ F(
    "div",
    {
      className: `${n.chatInput} ${i ? n.disabled : ""} ${G ?? ""} ${(a == null ? void 0 : a.chatInput) ?? ""}`,
      id: "chat-input",
      ref: b,
      children: [
        /* @__PURE__ */ s(
          "input",
          {
            ref: $,
            type: "file",
            className: n.fileInput,
            multiple: !0,
            onChange: ie,
            disabled: i
          }
        ),
        C ? /* @__PURE__ */ s("img", { src: C, className: n.preTextIcon }) : null,
        /* @__PURE__ */ F(
          "div",
          {
            ref: _,
            className: `${n.actions} ${r && (r == null ? void 0 : r.length) > 0 ? n.overlapping : ""}`,
            children: [
              M ? null : /* @__PURE__ */ s("button", { className: n.attachButton, onClick: ne, children: /* @__PURE__ */ s(pe, {}) }),
              /* @__PURE__ */ s(
                "button",
                {
                  className: `${n.sendButton} ${x.trim() || (r == null ? void 0 : r.length) > 0 ? n.hasText : ""}`,
                  onClick: N,
                  id: "send-button",
                  "aria-label": "send-button",
                  children: /* @__PURE__ */ F("div", { className: n.sendArrowImageWrapper, children: [
                    /* @__PURE__ */ s("div", { className: n.sendArrowWrapperHover, children: /* @__PURE__ */ s(L, { className: n.sendArrow }) }),
                    /* @__PURE__ */ s("div", { className: n.sendArrowWrapper, children: /* @__PURE__ */ s(L, { className: n.sendArrow }) })
                  ] })
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ F(
          "div",
          {
            ref: B,
            className: `${n.inputs} ${M ? n.noFiles : ""} ${q ?? ""} ${(a == null ? void 0 : a.inputContainer) ?? ""}`,
            children: [
              E && (u == null ? void 0 : u.length) > 0 ? /* @__PURE__ */ s("div", { className: n.truncateOnBlurContainer, children: oe(u) }) : null,
              /* @__PURE__ */ s(
                "textarea",
                {
                  id: D ?? "chat-input-textarea",
                  ref: d,
                  className: `${n.textareaInput} ${E && (u == null ? void 0 : u.length) > 0 ? n.withTruncate : ""} ${C ? n.withPreTextIcon : ""} ${(a == null ? void 0 : a.textarea) ?? ""}`,
                  value: u,
                  onChange: le,
                  onKeyDown: te,
                  rows: 1,
                  placeholder: Q ?? void 0,
                  autoFocus: X,
                  onPaste: re,
                  onInput: J,
                  onFocus: Y,
                  onBlur: Z
                },
                D ?? "chat-input-textarea"
              ),
              r && (r == null ? void 0 : r.length) > 0 && !i ? /* @__PURE__ */ s("div", { ref: ee, className: n.files, children: r.map((e, t) => /* @__PURE__ */ s(
                fe,
                {
                  filename: e.name,
                  removeFile: () => se(t)
                },
                e.name
              )) }) : null
            ]
          }
        )
      ]
    }
  );
  return /* @__PURE__ */ s(
    "div",
    {
      className: `${n.chatInputContainer} ${(a == null ? void 0 : a.container) ?? ""} ${z ?? ""}`,
      ref: V,
      children: U ? /* @__PURE__ */ s(de, { className: (a == null ? void 0 : a.shinyInput) ?? "", children: H }) : H
    }
  );
});
he.displayName = "ChatInput";
export {
  he as ChatInput
};
